import actions from "./account-actions";
import getters from "./account-getters";
import mutations from "./account-mutations";
import state from "./account-state";
const accountStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default accountStore;